import axios from 'axios';

const getAuthHeader = () => {
    const token = sessionStorage.getItem('token');
    const header = {
        headers: { 
            Authorization: "Bearer " + token
     }
    };
    return header;
}

export const vanSubsNGeniusPaymentGateway = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/transport/n-genius/get_url`
    return axios.post(url,body,getAuthHeader()).then((res) => {
        return res.data
    })
}

export const getVanPayfortUrl =async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/transport-payfort`
    return axios.post(url,data,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getVanCCavenuePaymentGateway =async(data)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/transport/ccavenue-payment`
    return axios.post(url,data,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const vanSubsTransactions = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/transactionList`
    return axios.get(url,getAuthHeader()).then((res) => {
        return res.data
    })
}

export const getTransactionsList = async(id) => {
    const url = `${process.env.REACT_APP_API_URL}/api/transaction`
    return axios.post(url,{student_id:id},getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getFeeStructure = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/fee-structure`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getVanSubscriptionDetail = async() => {
    const url=`${process.env.REACT_APP_API_URL}/api/subscription_detail`
    return axios.get(url,getAuthHeader()).then((res) => {
        return res.data
    })
}
export const getVanSubscriptionPlan = async() => {
    const url=`${process.env.REACT_APP_API_URL}/api/subscription_plans`
    return axios.get(url,getAuthHeader()).then((res) => {
        return res.data
    })
}